import { createSelector } from '@reduxjs/toolkit'
import { RootState } from '../types'

const selectUserInfoState = (state: RootState) => state.userInfo

export const selectUserInfo = createSelector(selectUserInfoState, state => state.userInfo)
export const selectUserInfoLoading = createSelector(selectUserInfoState, state => state.isLoading)
